import React from 'react';
import { Button, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import PropTypes from 'prop-types';

const AddConditionalPathButton = ({ disabled, onClick, classes, data }) => {
  return (
    <Tooltip
      title={<span className={classes.addPathTooltipTitle}>Add a Conditional Path</span>}
      placement="bottom"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        },
      }}
    >
      <span>
        <Button
          variant="outlined"
          disabled={disabled}
          className={classes.addPathButton}
          onClick={event => {
            event.stopPropagation();
            onClick(data);
          }}
          id="add-conditional-path-button"
        >
          <AddIcon className={classes.addPathIcon} />
          <AltRouteIcon className={classes.addPathIcon} />
        </Button>
      </span>
    </Tooltip>
  );
};

AddConditionalPathButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default AddConditionalPathButton;
